import 'expo-asset';
import 'expo-dev-client';
import { registerRootComponent } from 'expo';
import React from 'react';

import { Root } from './src/Root';

const Index = () => <Root />;

registerRootComponent(Index);
